
export class LeadListSource {
  static maxSourceCount = 15;

  /**
   * Normalizes the weight of each source to range from 0 to 100.
   */
  static normalize(sources: LeadListSource[]): LeadListSource[] {
    const totalWeight = sources.reduce((totalWeight, source) =>
      totalWeight + source.weight, 0);

    return sources.map(source => new LeadListSource({
      dialGroupId: source.dialGroupId,
      weight: Math.ceil((source.weight / totalWeight) * 100)
    }));
  }

  /**
   * Noramlizes the weight of each source to range from 0 to 100.
   * The weight of (the previous) `updatedSource` in `sources` will be 
   */
  static distributeWeight(sources: LeadListSource[], updatedSource: LeadListSource): LeadListSource[] {
    const totalWeight = sources.reduce((totalWeight, source) =>
      totalWeight + source.weight, 0);

    return LeadListSource.normalize(
      sources.map(source => {
        if (source.dialGroupId === updatedSource.dialGroupId) {
          return new LeadListSource({
            ...source,
            weight: source.weight
          })
        }

        return source;
      })
    );
  }

  readonly dialGroupId: string;
  /**
   * UI only. For convenience.
   */
  readonly leadListName?: string;
  readonly weight: number;

  constructor(deriveFrom?: Partial<LeadListSource>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }
  }
}